<!-- apps/wallet/src/components/pro/ProBadge.vue -->

<template>
  <span class="inline-flex rounded-full bg-amber-500 px-2.5 py-1 text-xs font-black uppercase tracking-wide text-gray-950">
    PRO
  </span>
</template>
